import React from 'react';
import {Label, Input} from 'components';
import {format} from 'date-fns';
import i18n from 'i18next';

type MeetingFormProps = {
  dateValue: Date;
  setDateValue: (newValue: Date) => void;
  disabled?: boolean;
};

function MeetingForm({dateValue, setDateValue, disabled}: MeetingFormProps) {
  return (
    <>
      <div className="mb-10" />
      <Label
        htmlFor="date-form"
        label={i18n.t('wisbitPage.addComponentModal.meetingForm.dateLabel')}
      >
        <Input
          id="date-form"
          type="datetime-local"
          value={format(dateValue, "yyyy-MM-dd'T'HH:mm")}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setDateValue(new Date(event.target.value))
          }
          disabled={disabled}
        />
      </Label>
    </>
  );
}

export default MeetingForm;
